export default "__VITE_ASSET__b0795513__"